import styled from "styled-components";

const Dialog = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-width: 25em;
  height: 100%;
`;

export default Dialog;
